import { connect } from 'react-redux';
import NavigationMenu from './navigation-menu.component';

const mapStateToProps = ({ player }) => ({
  activeTheme: player.ebookData.activeTheme,
});

export default connect(mapStateToProps)(NavigationMenu);
